const STORAGE_KEY = 'pondstat_sidebar_minified';

export function getStoredSidebarMinified() {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function storeSidebarMinified(isMinified) {
  try {
    localStorage.setItem(STORAGE_KEY, isMinified ? 'true' : 'false');
  } catch {
    // ignore quota / private mode
  }
}
